(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_06b8262"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('faq-accordion')) {
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const headingToggle = event.target.closest('[data-faq-heading-toggle]');
        if (headingToggle) {
          this.toggleList(headingToggle);
          return;
        }

        const questionButton = event.target.closest('[data-faq-button]');
        if (questionButton) {
          this.toggleItem(questionButton);
        }
      }

      toggleList(headingToggle) {
        const isActive = this.classList.contains('list-active');

        if (isActive) {
          this.classList.remove('list-active');
          headingToggle.setAttribute('aria-expanded', 'false');
        } else {
          this.classList.add('list-active');
          headingToggle.setAttribute('aria-expanded', 'true');
        }
      }

      toggleItem(button) {
        const item = button.closest('[data-faq-item]');
        if (!item) return;
        const answer = item.querySelector('[data-faq-answer]');
        if (!answer) return;

        const isActive = item.classList.contains('active');

        if (isActive) {
          item.classList.remove('active');
          answer.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('active');
          answer.classList.add('active');
          button.setAttribute('aria-expanded', 'true');
        }
      }
    }

    customElements.define('faq-accordion', FaqAccordion);
  }
  } catch(e) { console.error(e); }
})();

})();
